import { render, staticRenderFns } from "./PlatUse.vue?vue&type=template&id=71d10a84"
import script from "./PlatUse.vue?vue&type=script&lang=js"
export * from "./PlatUse.vue?vue&type=script&lang=js"
import style0 from "./PlatUse.vue?vue&type=style&index=0&id=71d10a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports